import React, { useEffect } from 'react';
import { Menu, Container, Dropdown, Image, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { logout } from '../../containers/User/userActions';
import './style.scss';
import Logo from './Logo';
import styleConstants from 'assets/styles/style-constants';
import Render from 'components/Render';
import { useAuth0 } from '@auth0/auth0-react';
import { getFirstName } from 'app/helpers/userHelper';
var Header = function (props) {
    var user = props.user;
    if (!user)
        return null;
    var name = getFirstName(user);
    var _a = (user && user.app_metadata && user.app_metadata) || {}, createdAt = _a.createdAt, sandboxBrowserTour = _a.sandboxBrowserTour;
    var currentTime = Date.now();
    var localStoragePersona = window.localStorage && window.localStorage.getItem('neo4j_persona');
    var shouldShowAuraBanner = localStoragePersona !== 'data-scientist' &&
        createdAt &&
        (currentTime - createdAt > 30 * 60 * 60 * 1000 || sandboxBrowserTour);
    useEffect(function () {
        if (shouldShowAuraBanner)
            window.neo4jSandbox.tracking.event('SANDBOX_AURA_BANNER_SHOW');
    }, []);
    var handleAuraCtaClick = function () { return window.neo4jSandbox.tracking.event('SANDBOX_AURA_BANNER_CLICK'); };
    var logout = useAuth0().logout;
    var handleLogout = function () {
        // props.onLogout();
        window.neo4jSandbox.tracking.event('LOGGED_OUT');
        logout({
            returnTo: window.location.href,
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Render, { if: shouldShowAuraBanner },
            React.createElement("div", { style: {
                    background: styleConstants.colors.primary.DEFAULT,
                    color: 'white',
                    padding: '12px',
                    textAlign: 'center',
                    fontSize: 16,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                } },
                React.createElement("span", { style: {
                        display: 'inline-block',
                        paddingRight: 24,
                        textAlign: 'left',
                    } },
                    "Continue in the cloud with",
                    ' ',
                    React.createElement("u", { style: { textDecorationStyle: 'dotted', textUnderlineOffset: 4 } }, "no time limit"),
                    " -",
                    React.createElement("em", null, "free forever, no credit card required")),
                React.createElement(Button, { color: "pink", size: "small", href: "https://neo4j.com/cloud/aura/?ref=sandbox-header", target: "_blank", onClick: handleAuraCtaClick }, "Start Free on AuraDB"))),
        React.createElement(Menu, { borderless: true, style: { marginTop: 0 } },
            React.createElement(Container, null,
                React.createElement(Menu.Item, { style: { paddingLeft: 0 } },
                    React.createElement(Logo, { height: 36 })),
                React.createElement(Menu.Menu, { position: "right" },
                    React.createElement(Menu.Item, null,
                        React.createElement("a", { href: "https://neo4j.com/", className: "uncolored-link", target: "_blank", rel: "noreferrer" }, "Go to neo4j.com")),
                    React.createElement(Menu.Item, { className: "pr0" },
                        React.createElement(Dropdown, { item: true, text: name ? "Hi ".concat(name) : '' },
                            React.createElement(Dropdown.Menu, null,
                                React.createElement(Dropdown.Item, { onClick: handleLogout, className: "uncolored-link" }, "Logout"))),
                        React.createElement("span", { style: { display: 'inline-block' } },
                            React.createElement(Image, { src: user.picture, avatar: true }))))))));
};
var mapDispatchToProps = function (dispatch) { return ({
    onLogout: function () { return dispatch(logout()); },
}); };
var mapStateToProps = function (state) { return ({
    user: state.user,
}); };
export default connect(mapStateToProps, mapDispatchToProps)(Header);
